var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTessaError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8f8f8f",
    fillRule: "evenodd",
    d: "M10.728 22.002A7.45 7.45 0 0 0 14.51 23a7.4 7.4 0 0 0 3.763-.998 7.85 7.85 0 0 0 2.73-2.73A7.4 7.4 0 0 0 22 15.509c0-1.366-.332-2.626-.997-3.764a7.75 7.75 0 0 0-2.731-2.748A7.4 7.4 0 0 0 14.509 8a7.45 7.45 0 0 0-3.78.997 7.75 7.75 0 0 0-2.73 2.748C7.332 12.883 7 14.143 7 15.51c0 1.365.333 2.607.998 3.763a7.84 7.84 0 0 0 2.73 2.73zm2.468-11.43c.07-.052.14-.07.228-.07h2.153c.087 0 .175.018.228.07.069.054.104.106.104.193l-.175 6.056c0 .07-.035.122-.105.175a.35.35 0 0 1-.228.07H13.6a.37.37 0 0 1-.245-.07c-.053-.053-.088-.105-.088-.175l-.175-6.056c0-.087.035-.14.105-.192zm.053 7.755a.25.25 0 0 1 .105-.21.28.28 0 0 1 .227-.105h1.873c.088 0 .158.034.21.087a.37.37 0 0 1 .088.228v1.855a.37.37 0 0 1-.088.228.3.3 0 0 1-.21.087h-1.873a.28.28 0 0 1-.227-.105.27.27 0 0 1-.105-.21z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTessaError);
export default __webpack_public_path__ + "static/media/tessa-error.a9089f4b4e521aa8bfb2805a87608734.svg";
export { ForwardRef as ReactComponent };